import styled from '@emotion/styled'
import { jsx, keyframes } from '@emotion/react'
import React from 'react'

const TickerPage = styled.div`
    transform: translate(0px, 250px);
    mix-blend-mode: difference;
`
const TickerWrapper = styled.section`
    position: relative;
    width: 100%;
    overflow: hidden;
    transform: rotate(353deg) translate(14px, -140px);
      
`
const AnimateRightLeft = keyframes`
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(-100%);
    }
`
const AnimateRightLeft2 = keyframes`
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-200%);
    }
`
const TickerScroller = styled.div`
    display: flex;
    width: 100%;
    box-shadow: 0 8px 16px rgba(#000000, 0.5);
    
    
    div {
      font-weight: 900;
      font-size: 4em;
      text-transform: uppercase;
      white-space: nowrap;
      color: #14147e;
      animation: ${AnimateRightLeft} 40s -40s linear infinite;
      will-change: transform;      
      
      &:nth-child(2) {
        animation: ${AnimateRightLeft2} 40s -20s linear infinite;
      }
    }
`
const AnimateLeftRight = keyframes`
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
`
const AnimateLeftRight2 = keyframes`
    0% {
        transform: translateX(-200%);
    }
    100% {
        transform: translateX(0);
    }
`
const TickerScrollerReverse = styled.div`
    display: flex;
    width: 100%;
    box-shadow: 0 8px 16px rgba(#000000, 0.5);
    
    div {
      font-weight: 900;
      font-size: 4em;
      text-transform: uppercase;
      white-space: nowrap;
      color: #14147e;
      animation: ${AnimateLeftRight} 40s -40s linear infinite;
      will-change: transform;
      
      &:nth-child(2) {
        animation: ${AnimateLeftRight2} 40s -20s linear infinite;
      }
    }
`

export const Ticker = () => {
  return (
    <TickerPage>
        <TickerWrapper> 
            <TickerScroller>
                <div>
                    hold and Earn $pulse hold and Earn $pulse hold and Earn $pulse hold and Earn $pulse
                </div>
                <div>
                    hold and Earn $pulse hold and Earn $pulse hold and Earn $pulse hold and Earn $pulse
                </div>
            </TickerScroller>
            <TickerScrollerReverse>
                <div>
                    Print easy money Print easy money Print easy money Print easy money
                </div>
                <div>
                    Print easy money Print easy money Print easy money Print easy money
                </div>
            </TickerScrollerReverse>
        </TickerWrapper>
        <div style={{height: 230}} />
    </TickerPage>
  )
}
